import { mapActions, mapState, mapMutations } from "vuex";
import Protocol from "@/behaviors/protocols/redirect";
import RedirectPayloadError from "@/errors/errors";
import { cloneDeep } from "lodash";

export default {
  computed: {
    ...mapState(["invoiceInitialData", "flowData"]),
  },

  methods: {
    ...mapActions(["createPaymentInvoice"]),
    ...mapMutations(["SET_CURRENT_STEP"]),
    ...mapActions("UI", ["ADD_MESSAGE"]),

    async makePayment(payment_service, fields) {
      this.SET_CURRENT_STEP(2);
      this.isLoadingRedirect = true ;
      if (fields === undefined) fields = {};

      const {
        currency,
        public_key,
        amount,
        description = new Date(),
        expires = null,
        metadata = null,
        reference_id = null
      } = this.invoiceInitialData;

      const { code, method } = payment_service;

      let data = {
        public_key,
        reference_id: reference_id ? reference_id : Math.random().toString(36).substring(2) + (new Date()).getTime().toString(36),
        service: code,
        currency,
        amount,
      };

      // TODO: God, please forgive me.
      if (description && description.length) {
        data.description = description;
      }

      if (expires && expires.length) {
        data.expires = expires;
      }

      //TODO: implement type checking
      if(metadata) {
        data.metadata = metadata;
      }

      if (Object.keys(fields).length > 0) {
        data.service_fields = cloneDeep(fields);
      }

      try {
        /**
         * In createPaymentInvoice action will be mutation, that setted flowData
         */
        await this.createPaymentInvoice(data);

        // TODO: Decompozite this thing
        const redirectData = cloneDeep(this.flowData.payload);
        if (!redirectData) {
          throw new RedirectPayloadError("no-payload-data");
        }

        redirectData.blank =
          !(window === window.parent) &&
          payment_service.code.includes("privat24") != -1
            ? true
            : false;

        redirectData.blank = false;

        // HARDCODE!!! This condition is necessary to complete processing through the test provider.
        // There was an error after payment, the page did not redirect anywhere
        if (method === "test" && this.flowData.status === "created") {
          this.ADD_MESSAGE({
            text: this.$t("success"),
            type: "success",
          });
          this.$router.push({ name: "PaymentMethodsListPage" });
          return;
        }

        console.log("Redirect data", redirectData);
        await Protocol.redirect(redirectData);
        setTimeout(() => {
          this.isLoadingRedirect = false;
        }, 2000);

        return Promise.resolve({
          flowType: redirectData,
        });
      } catch (e) {
        this.SET_CURRENT_STEP(1);
        this.isLoadingRedirect = false;
        throw e;
      } finally {
      }
    },
  },
};
